import {unmockedGraphQlOperationsStore} from 'src/test/shared/store';

import type {GqlError} from 'src/internal/revamp/graphql/GqlError';
import type Headerz from 'src/internal/shared/headers/headers';
import type {MockStore} from 'src/test/shared/store';
import type {FetchOptions, GraphQlResponseError} from 'src/types';

export type GraphQlMockResponseNew<TData, TErrorExtensions> = {
  errors?: Array<GqlError<TErrorExtensions>> | null;
  data?: TData | null;
};

export type FetchMockResponse = {
  body: string;
  headers?: Headerz;
  status?: number;
};

export type GraphQlMockOptions<TVariables> = {
  variables: TVariables;
};

export type GraphQlMockResponseOld<TData> = {
  data?: TData | null;
  error?: never; // Prevent a common mistake
  errors?: Array<GraphQlResponseError>;
};

export type GraphQlMockResponse<TData, TErrorExtensions = never> = [
  TErrorExtensions,
] extends [never]
  ? GraphQlMockResponseOld<TData>
  : GraphQlMockResponseNew<TData, TErrorExtensions>;

type StorageCallback = (name: string, value: string | null) => void;

export const fetchMockStore: MockStore<
  FetchOptions,
  FetchMockResponse | Promise<FetchMockResponse>
> = new Map();

type GraphQlMockStoreValuesType =
  | GraphQlMockResponseOld<any>
  | Promise<GraphQlMockResponseOld<any>>
  | GraphQlMockResponseNew<any, any>
  | Promise<GraphQlMockResponseNew<any, any>>;

export const graphQlMockStore: MockStore<
  GraphQlMockOptions<any>,
  GraphQlMockStoreValuesType
> = new Map();

export const unmockedFetchCallsStore: Set<string> = new Set();

export const readCookies: Map<string, Set<StorageCallback>> = new Map();
export const readLocalStorage: Map<string, Set<StorageCallback>> = new Map();
export const readSessionStorage: Map<string, Set<StorageCallback>> = new Map();

declare global {
  // eslint-disable-next-line no-var, vars-on-top
  var __sdkAfterDataStore: boolean;
}

if (typeof afterEach === 'function' && !globalThis.__sdkAfterDataStore) {
  globalThis.__sdkAfterDataStore = true;

  afterEach(() => {
    fetchMockStore.clear();
    graphQlMockStore.clear();
    unmockedFetchCallsStore.clear();
    readCookies.clear();
    readLocalStorage.clear();
    readSessionStorage.clear();
    unmockedGraphQlOperationsStore.clear();
  });
}
